import * as actions from 'actions/pincodeActions';
import { SlotType } from 'rome-models/models/com/flipkart/rome/datatypes/response/page/v4/SlotType';
import { WidgetTypeV4 } from 'rome-models/models/com/flipkart/rome/datatypes/response/page/v4/WidgetTypeV4';
import { INIT, LOADING, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import { PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';
import { get } from 'lodash';
export const SELECT_CITY_TEXT = 'Select city';
const DELIVERY_PIN_TEXT = 'Where do you want the delivery ?';
const ENTER_PIN_TEXT = 'Please enter pincode';
const getPincodeWidgetData = slots => {
    return slots.find(slot => slot.slotType === SlotType.WIDGET && get(slot, 'widget.type') === WidgetTypeV4.PINCODE_SERVICEABILITY);
};
const getMNSPincodeWidgetData = slots => {
    return slots.find(slot => slot.slotType === SlotType.WIDGET && get(slot, 'widget.type') === WidgetTypeV4.MNS_PINCODE_POPUP);
};
const mnsPincodeWidgetData = (widgetData) => {
    const data = get(widgetData, ['widget', 'data']);
    const widgetTitle = data.title;
    const popupMessage = data.subTitle;
    const viewType = get(widgetData, ['widget', 'viewType']) || '';
    return {
        widgetText: SELECT_CITY_TEXT,
        widgetTitle,
        popupMessage,
        viewType,
        serviceable: false,
        errorMessage: ENTER_PIN_TEXT,
        marketplace: get(data.positiveButton, ['action', 'params', 'marketplace']),
        negativeButton: data.negativeButton
    };
};
const pincodeWidgetValue = (widgetData) => {
    const data = get(widgetData, [
        'widget',
        'data',
        'renderableComponents',
        0
    ]);
    const pincodeValue = get(data, ['value']);
    const serviceable = get(pincodeValue, 'serviceable') || false;
    const serviceableMessage = get(pincodeValue, ['serviceableMessage']);
    const pincode = get(pincodeValue, ['pincode']);
    const message = get(pincodeValue, ['serviceableSubText']);
    const popupMessage = get(pincodeValue, ['popupMessage']);
    const marketplace = get(data, ['action', 'params', 'marketplace']);
    const viewType = widgetData.viewType;
    return {
        widgetTitle: DELIVERY_PIN_TEXT,
        pincode,
        marketplace,
        serviceable,
        serviceableMessage,
        widgetText: serviceable ? `${serviceableMessage} ${pincode}` : SELECT_CITY_TEXT,
        errorMessage: '',
        popupMessage,
        message,
        viewType
    };
};
const defaultState = {
    widgetTitle: DELIVERY_PIN_TEXT,
    serviceable: false,
    asyncStatus: INIT,
    widgetText: SELECT_CITY_TEXT
};
export default function marketPlacePincode(state = defaultState, action) {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.SUCCESS:
            const slots = get(action, 'data.slots');
            if (!slots)
                return state;
            const mnsPincodeWidget = getMNSPincodeWidgetData(slots);
            const pincodeWidgetData = getPincodeWidgetData(slots);
            if (mnsPincodeWidget) {
                const mnsPincodeState = mnsPincodeWidgetData(mnsPincodeWidget);
                return Object.assign({}, mnsPincodeState, {
                    type: WidgetTypeV4.MNS_PINCODE_POPUP,
                    asyncStatus: ERROR
                });
            }
            else if (pincodeWidgetData) {
                const pincodeState = pincodeWidgetValue(pincodeWidgetData);
                return Object.assign({}, state, pincodeState, {
                    type: WidgetTypeV4.PINCODE_SERVICEABILITY,
                    asyncStatus: pincodeState.serviceable ? SUCCESS : ERROR
                });
            }
            return defaultState;
        case actions.PINCODE_SERVICEABILTY.REQUEST:
            return Object.assign({}, state, {
                requestedPincode: action.pincode,
                pincode: state.pincode,
                asyncStatus: LOADING
            });
        case actions.PINCODE_SERVICEABILTY.SUCCESS:
            const successAction = action;
            if (successAction.serviceability) {
                const pincodeText = successAction.pincode;
                const widgetText = (state.serviceableMessage && `${state.serviceableMessage} ${pincodeText}`) || SELECT_CITY_TEXT;
                return Object.assign({}, state, {
                    marketplace: successAction.marketplace,
                    serviceable: successAction.serviceability,
                    pincode: pincodeText,
                    asyncStatus: SUCCESS,
                    widgetText,
                    errorMessage: successAction.message,
                    requestedPincode: successAction.pincode
                });
            }
            else {
                return Object.assign({}, state, {
                    asyncStatus: ERROR,
                    errorMessage: successAction.message
                });
            }
        case actions.PINCODE_SERVICEABILTY.ERROR:
            return Object.assign({}, state, {
                errorMessage: action.errorMessage,
                asyncStatus: ERROR
            });
        default: {
            return state;
        }
    }
}
